export const defaultHumanMeanTemplate = (baseDate: Date = new Date()) => `{
  "role": "DRIVER",
  "description": "Primary linehaul driver",
  "allocationDate": "${baseDate.toISOString()}",
  "contacts": [
    {
      "role": "PROVIDER",
      "persons": [
        {
          "givenName": "Marc",
          "familyName": "Lefevre",
          "email": "marc.lefevre@example.com",
          "telephone": "+33601020304"
        }
      ]
    }
  ],
  "pieces": [
    {
      "uri": "urn:bol:piece:pce-001"
    }
  ],
  "isLinkedToResources": [
    "urn:bol:material-mean:mm-001"
  ],
  "externalReferences": [
    {
      "externalReferenceType": "OWNER_ID",
      "reference": "HM-2026-001"
    }
  ]
}`;
